import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HomeOutlined } from "@ant-design/icons";
import { Result } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../../others/i18n.js";
import { useStores } from "../../../store/root.js";
import { ESessionState } from "../../../types/store/authentication.js";
const RouteRealCookieBannerContent = observer(()=>{
    const { t } = useTranslation();
    const { timerStore } = useStores();
    const navigate = useNavigate();
    const { rcbAuthenticationStore } = useStores();
    const { sessionState } = rcbAuthenticationStore;
    useEffect(()=>{
        if (sessionState === ESessionState.Stored) {
            navigate("/rcb/service"); // CU-861m42ag6, try redirect when logged in
        }
    }, [
        sessionState
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                children: /*#__PURE__*/ _jsx("title", {
                    children: t("Real Cookie Banner")
                })
            }),
            /*#__PURE__*/ _jsx(Result, {
                icon: /*#__PURE__*/ _jsx(HomeOutlined, {}),
                title: t("Real Cookie Banner Cloud Management")
            }),
            /*#__PURE__*/ _jsx("p", {
                style: {
                    textAlign: "center"
                },
                children: t("You wasted already {{secondsPassed}} seconds here.", {
                    secondsPassed: timerStore.secondsPassed
                })
            })
        ]
    });
});
export { RouteRealCookieBannerContent };
